import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import { createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "grid min-h-0 flex-1 grid-cols-1 gap-6 lg:grid-cols-12"
};
const _hoisted_2 = {
  class: "lg:col-span-3"
};
const _hoisted_3 = {
  class: "flex min-h-0 flex-col lg:col-span-9"
};
const _hoisted_4 = {
  class: "list-page-table-panel list-page-table-panel--fill"
};
const _hoisted_5 = {
  class: "flex flex-wrap items-center justify-end gap-2 border-b border-slate-200 px-4 py-3"
};
const _hoisted_6 = ["disabled"];
const _hoisted_7 = ["disabled"];
const _hoisted_8 = {
  class: "filter-bar-field is-wide relative"
};
const _hoisted_9 = {
  class: "data-table-shell"
};
const _hoisted_10 = {
  class: "data-table-scroll data-table-scroll--fill"
};
const _hoisted_11 = {
  class: "data-table text-sm min-w-[960px]"
};
const _hoisted_12 = {
  class: "data-table-head"
};
const _hoisted_13 = {
  class: "data-table-th text-left w-10"
};
const _hoisted_14 = ["checked", "indeterminate"];
const _hoisted_15 = {
  class: "data-table-body"
};
const _hoisted_16 = {
  key: 1
};
const _hoisted_17 = {
  colspan: "8",
  class: "data-table-empty text-sm text-slate-500"
};
const _hoisted_18 = {
  key: 0,
  class: "flex flex-col items-center"
};
const _hoisted_19 = {
  key: 1,
  class: "flex flex-col items-center"
};
const _hoisted_20 = {
  class: "data-table-td"
};
const _hoisted_21 = ["checked", "onChange"];
const _hoisted_22 = {
  class: "data-table-td"
};
const _hoisted_23 = {
  class: "data-table-cell-title"
};
const _hoisted_24 = {
  class: "data-table-cell-meta"
};
const _hoisted_25 = {
  class: "data-table-td text-slate-600"
};
const _hoisted_26 = {
  class: "data-table-td is-right font-medium text-primary-600"
};
const _hoisted_27 = {
  class: "data-table-td is-center text-slate-600"
};
const _hoisted_28 = {
  class: "data-table-td is-center"
};
const _hoisted_29 = {
  class: "data-table-td text-slate-600"
};
const _hoisted_30 = {
  class: "data-table-td data-table-sticky-right data-table-sticky-action"
};
const _hoisted_31 = {
  class: "flex items-center justify-center gap-2"
};
const _hoisted_32 = ["onClick"];
import { ref, reactive, computed, onMounted } from 'vue';
import ProductCategorySidebar from '@/components/ProductCategorySidebar.vue';
import ProductSelector from './components/ProductSelector.vue';
import ProductDetailModal from '@/components/ProductDetailModal.vue';
import AppPagination from '@/components/AppPagination.vue';
import ListPageShell from '@/components/ListPageShell.vue';
import PageFilterBar from '@/components/PageFilterBar.vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { getFranchiseePage, authorizeProducts, revokeProducts } from '@/api';
import { getProductPage, getProductCategories, getUnauthorizedProductTree } from '@/api/product';

// 加载状态

export default {
  __name: 'FranchiseeProductManagement',
  setup(__props) {
    const loading = ref(false);
    const categoryLoading = ref(false);
    const authorizeLoading = ref(false);
    const selectorLoading = ref(false);

    // 加盟商列表
    const franchisees = ref([]);
    const selectedFranchiseeId = ref(null);
    const selectedFranchiseeName = computed(() => {
      const franchisee = franchisees.value.find(f => f.id === selectedFranchiseeId.value);
      return franchisee?.name || '';
    });
    const authorizeDescription = computed(() => {
      return `为加盟商 "${selectedFranchiseeName.value}" 选择要授权的产品`;
    });

    // 产品类目
    const categories = ref([]);
    const allCategories = ref([]);

    // 产品列表
    const products = ref([]);

    // 搜索表单
    const searchForm = reactive({
      categoryId: null,
      keyword: ''
    });
    const selectedCategory = ref('');

    // 分页
    const pagination = reactive({
      current: 1,
      size: 10,
      total: 0,
      pages: 0,
      hasNext: false,
      hasPrevious: false
    });

    // 选中产品
    const selectedProductIds = ref([]);
    const isAllSelected = computed(() => {
      return products.value.length > 0 && selectedProductIds.value.length === products.value.length;
    });
    const isIndeterminate = computed(() => {
      return selectedProductIds.value.length > 0 && selectedProductIds.value.length < products.value.length;
    });

    // 新增授权弹窗
    const showAddModal = ref(false);
    const unauthorizedProductTree = ref([]);
    const addSelectedProductIds = ref([]);

    // 产品详情弹窗
    const showDetailModal = ref(false);
    const selectedProductId = ref(null);

    // 加载加盟商列表
    const loadFranchisees = async () => {
      try {
        const res = await getFranchiseePage({
          statuses: [3],
          current: 1,
          size: 999
        });
        franchisees.value = res.records || [];
      } catch (error) {
        console.error('加载加盟商列表失败:', error);
      }
    };

    // 加载类目
    const loadCategories = async () => {
      categoryLoading.value = true;
      try {
        const res = await getProductCategories();
        categories.value = res || [];
        allCategories.value = res || [];
      } catch (error) {
        console.error('加载类目失败:', error);
      } finally {
        categoryLoading.value = false;
      }
    };

    // 加载产品列表
    const loadProducts = async () => {
      // 必须先选择加盟商
      if (!selectedFranchiseeId.value) {
        products.value = [];
        pagination.total = 0;
        pagination.current = 1;
        return;
      }
      loading.value = true;
      try {
        const params = {
          tenantId: selectedFranchiseeId.value,
          categoryId: searchForm.categoryId || undefined,
          keyword: searchForm.keyword || undefined,
          status: 1,
          // 只查询上架的产品
          page: pagination.current,
          size: pagination.size
        };
        const res = await getProductPage(params);
        products.value = res.records || [];
        pagination.total = res.total || 0;
        pagination.pages = res.pages || 0;
        pagination.hasNext = res.hasNext || false;
        pagination.hasPrevious = res.hasPrevious || false;
      } catch (error) {
        console.error('加载产品列表失败:', error);
        ElMessage.error('加载产品列表失败');
      } finally {
        loading.value = false;
      }
    };

    // 搜索
    const handleSearch = () => {
      pagination.current = 1;
      loadProducts();
    };

    // 重置
    const handleReset = () => {
      selectedCategory.value = '';
      searchForm.categoryId = null;
      searchForm.keyword = '';
      pagination.current = 1;
      loadProducts();
    };

    // 获取类别名称
    const categoryName = categoryId => {
      const category = categories.value.find(item => item.id === categoryId);
      return category ? category.name : '-';
    };
    const applyCategoryFilter = async categoryId => {
      const nextValue = String(categoryId);
      selectedCategory.value = selectedCategory.value === nextValue ? '' : nextValue;
      searchForm.categoryId = selectedCategory.value ? Number(selectedCategory.value) : null;
      await loadProducts(1);
    };

    // 分页切换
    const handlePageChange = page => {
      if (page < 1 || page > pagination.pages) return;
      pagination.current = page;
      loadProducts();
    };
    const handlePageSizeChange = size => {
      pagination.size = size;
      pagination.current = 1;
      loadProducts();
    };

    // 加盟商选择变化
    const handleFranchiseeChange = async () => {
      selectedProductIds.value = [];
      pagination.current = 1;
      if (selectedFranchiseeId.value) {
        await loadProducts();
      } else {
        products.value = [];
      }
    };

    // 选择产品
    const toggleSelect = productId => {
      const index = selectedProductIds.value.indexOf(productId);
      if (index > -1) {
        selectedProductIds.value.splice(index, 1);
      } else {
        selectedProductIds.value.push(productId);
      }
    };

    // 全选/取消全选
    const toggleSelectAll = () => {
      if (isAllSelected.value) {
        selectedProductIds.value = [];
      } else {
        selectedProductIds.value = products.value.map(p => p.id);
      }
    };

    // 打开新增授权弹窗
    const openAddModal = async () => {
      addSelectedProductIds.value = [];
      showAddModal.value = true;
      // 加载未授权产品树
      if (selectedFranchiseeId.value) {
        selectorLoading.value = true;
        try {
          const res = await getUnauthorizedProductTree(selectedFranchiseeId.value);
          unauthorizedProductTree.value = res || [];
        } catch (error) {
          console.error('加载未授权产品失败:', error);
          ElMessage.error('加载未授权产品失败');
          unauthorizedProductTree.value = [];
        } finally {
          selectorLoading.value = false;
        }
      }
    };

    // 处理授权确认
    const handleAuthorizeConfirm = async selectedIds => {
      if (selectedIds.length === 0) return;
      authorizeLoading.value = true;
      try {
        await authorizeProducts(selectedFranchiseeId.value, selectedIds);
        ElMessage.success(`成功授权 ${selectedIds.length} 个产品`);
        showAddModal.value = false;
        await loadProducts();
      } catch (error) {
        console.error('授权失败:', error);
        ElMessage.error(error.message || '授权失败');
      } finally {
        authorizeLoading.value = false;
      }
    };

    // 批量取消授权
    const batchRevoke = async () => {
      if (selectedProductIds.value.length === 0) return;
      try {
        await ElMessageBox.confirm(`确定要取消该加盟商的 ${selectedProductIds.value.length} 个产品授权吗？`, '取消授权确认', {
          type: 'warning'
        });
        authorizeLoading.value = true;
        await revokeProducts(selectedFranchiseeId.value, selectedProductIds.value);
        ElMessage.success(`成功取消 ${selectedProductIds.value.length} 个产品授权`);
        selectedProductIds.value = [];
        await loadProducts();
      } catch (error) {
        if (error !== 'cancel') {
          console.error('取消授权失败:', error);
          ElMessage.error('取消授权失败');
        }
      } finally {
        authorizeLoading.value = false;
      }
    };

    // 查看详情
    const handleViewDetail = product => {
      selectedProductId.value = product.id;
      showDetailModal.value = true;
    };

    // 初始化
    onMounted(() => {
      loadFranchisees();
      loadCategories();
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createBlock(ListPageShell, {
        fill: ""
      }, {
        header: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createElementVNode("div", {
          class: "list-page-panel is-header-minimal"
        }, [_createElementVNode("div", {
          class: "list-page-heading"
        }, [_createElementVNode("div", {
          class: "list-page-heading-main"
        }, [_createElementVNode("h1", {
          class: "list-page-title"
        }, "加盟商产品授权管理"), _createElementVNode("p", {
          class: "list-page-description"
        }, " 管理加盟商的产品授权，包括授权产品的查看、添加和取消 ")])])], -1)]))]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(ProductCategorySidebar, {
          categories: categories.value,
          loading: categoryLoading.value,
          "selected-category-id": selectedCategory.value,
          title: "产品类目",
          description: "选择类目可筛选产品",
          "show-add-button": false,
          "show-actions": false,
          onSelect: applyCategoryFilter
        }, null, 8, ["categories", "loading", "selected-category-id"])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_select, {
          modelValue: selectedFranchiseeId.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => selectedFranchiseeId.value = $event),
          placeholder: "请选择加盟商",
          filterable: "",
          clearable: "",
          class: "form-select form-control-sm w-[220px]",
          onChange: handleFranchiseeChange
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(franchisees.value, f => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: f.id,
              label: f.name,
              value: f.id
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"]), selectedProductIds.value.length > 0 ? _withDirectives((_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          onClick: batchRevoke,
          disabled: authorizeLoading.value,
          class: "btn-danger"
        }, [_createTextVNode(" 取消授权 (" + _toDisplayString(selectedProductIds.value.length) + ") ", 1)], 8, _hoisted_6)), [[_directive_permission, 'franchisee:authorize']]) : _createCommentVNode("", true), _withDirectives((_openBlock(), _createElementBlock("button", {
          type: "button",
          onClick: openAddModal,
          disabled: !selectedFranchiseeId.value,
          class: "btn-primary"
        }, [...(_cache[7] || (_cache[7] = [_createElementVNode("svg", {
          class: "h-4 w-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M12 4v16m8-8H4"
        })], -1), _createTextVNode(" 新增授权 ", -1)]))], 8, _hoisted_7)), [[_directive_permission, 'franchisee:authorize']])]), _createVNode(PageFilterBar, {
          "shell-class": "filter-bar-shell is-embedded",
          "body-class": "filter-bar-body is-panel",
          "show-refresh": true,
          "refresh-loading": loading.value,
          onRefresh: loadProducts
        }, {
          searchActions: _withCtx(() => [_createElementVNode("button", {
            onClick: handleSearch,
            class: "btn-primary"
          }, " 搜索 "), _createElementVNode("button", {
            onClick: handleReset,
            class: "btn-secondary"
          }, " 重置 ")]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => searchForm.keyword = $event),
            type: "text",
            placeholder: "搜索产品名称或编码",
            class: "form-search-input form-control-sm w-full"
          }, null, 512), [[_vModelText, searchForm.keyword]]), _cache[8] || (_cache[8] = _createElementVNode("svg", {
            class: "absolute left-3 top-2.5 h-4 w-4 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          })], -1))]), _createVNode(_component_el_select, {
            modelValue: searchForm.categoryId,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => searchForm.categoryId = $event),
            placeholder: "请选择类目",
            class: "form-select form-control-sm filter-bar-field"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部类目",
              value: null
            }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, cat => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: cat.id,
                label: cat.name,
                value: cat.id
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }, 8, ["refresh-loading"]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("table", _hoisted_11, [_createElementVNode("thead", _hoisted_12, [_createElementVNode("tr", null, [_createElementVNode("th", _hoisted_13, [_createElementVNode("input", {
          type: "checkbox",
          checked: isAllSelected.value,
          indeterminate: isIndeterminate.value,
          onChange: toggleSelectAll,
          class: "form-check"
        }, null, 40, _hoisted_14)]), _cache[9] || (_cache[9] = _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "产品名称", -1)), _cache[10] || (_cache[10] = _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "摘要", -1)), _cache[11] || (_cache[11] = _createElementVNode("th", {
          class: "data-table-th is-right"
        }, "展示价", -1)), _cache[12] || (_cache[12] = _createElementVNode("th", {
          class: "data-table-th is-center"
        }, "周期(天)", -1)), _cache[13] || (_cache[13] = _createElementVNode("th", {
          class: "data-table-th is-center"
        }, "状态", -1)), _cache[14] || (_cache[14] = _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "类型", -1)), _cache[15] || (_cache[15] = _createElementVNode("th", {
          class: "data-table-th is-center data-table-sticky-right data-table-sticky-head data-table-sticky-action"
        }, "操作", -1))])]), _createElementVNode("tbody", _hoisted_15, [loading.value ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(5, n => {
          return _createElementVNode("tr", {
            key: n,
            class: "animate-pulse"
          }, [...(_cache[16] || (_cache[16] = [_createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "w-4 h-4 bg-slate-200 rounded"
          })], -1), _createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "flex items-center gap-3"
          }, [_createElementVNode("div", {
            class: "w-10 h-10 bg-slate-200 rounded-lg"
          }), _createElementVNode("div", null, [_createElementVNode("div", {
            class: "h-4 w-32 bg-slate-200 rounded mb-1"
          }), _createElementVNode("div", {
            class: "h-3 w-24 bg-slate-200 rounded"
          })])])], -1), _createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "h-4 w-24 bg-slate-200 rounded"
          })], -1), _createElementVNode("td", {
            class: "data-table-td is-right"
          }, [_createElementVNode("div", {
            class: "h-4 w-20 bg-slate-200 rounded ml-auto"
          })], -1), _createElementVNode("td", {
            class: "data-table-td is-center"
          }, [_createElementVNode("div", {
            class: "h-4 w-12 bg-slate-200 rounded mx-auto"
          })], -1), _createElementVNode("td", {
            class: "data-table-td is-center"
          }, [_createElementVNode("div", {
            class: "h-6 w-14 bg-slate-200 rounded-full mx-auto"
          })], -1), _createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "h-4 w-16 bg-slate-200 rounded"
          })], -1), _createElementVNode("td", {
            class: "data-table-td data-table-sticky-right data-table-sticky-action"
          }, [_createElementVNode("div", {
            class: "flex items-center justify-center gap-2"
          }, [_createElementVNode("div", {
            class: "h-8 w-8 bg-slate-200 rounded"
          }), _createElementVNode("div", {
            class: "h-8 w-8 bg-slate-200 rounded"
          })])], -1)]))]);
        }), 64)) : _createCommentVNode("", true), !loading.value && products.value.length === 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [_createElementVNode("td", _hoisted_17, [!selectedFranchiseeId.value ? (_openBlock(), _createElementBlock("div", _hoisted_18, [...(_cache[17] || (_cache[17] = [_createElementVNode("svg", {
          class: "w-12 h-12 text-slate-300 mb-2",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "1.5",
          d: "M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
        })], -1), _createElementVNode("p", null, "请先选择加盟商", -1)]))])) : (_openBlock(), _createElementBlock("div", _hoisted_19, [...(_cache[18] || (_cache[18] = [_createElementVNode("svg", {
          class: "w-12 h-12 text-slate-300 mb-2",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "1.5",
          d: "M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
        })], -1), _createElementVNode("p", null, "暂无产品数据", -1)]))]))])])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(products.value, product => {
          return _openBlock(), _createElementBlock("tr", {
            key: product.id,
            class: "data-table-row"
          }, [_createElementVNode("td", _hoisted_20, [_createElementVNode("input", {
            type: "checkbox",
            checked: selectedProductIds.value.includes(product.id),
            onChange: $event => toggleSelect(product.id),
            class: "form-check"
          }, null, 40, _hoisted_21)]), _createElementVNode("td", _hoisted_22, [_createElementVNode("div", _hoisted_23, _toDisplayString(product.name), 1), _createElementVNode("div", _hoisted_24, _toDisplayString(product.shortName || product.code), 1)]), _createElementVNode("td", _hoisted_25, _toDisplayString(product.summary || '-'), 1), _createElementVNode("td", _hoisted_26, _toDisplayString(product.priceDisplay || '-'), 1), _createElementVNode("td", _hoisted_27, _toDisplayString(product.durationDays ?? '-'), 1), _createElementVNode("td", _hoisted_28, [_createElementVNode("span", {
            class: _normalizeClass(['status-badge', product.status === 1 ? 'status-badge is-success' : 'status-badge is-neutral'])
          }, _toDisplayString(product.status === 1 ? '上架' : '下架'), 3)]), _createElementVNode("td", _hoisted_29, _toDisplayString(categoryName(product.categoryId)), 1), _createElementVNode("td", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_createElementVNode("button", {
            onClick: $event => handleViewDetail(product),
            class: "table-action-button is-primary",
            title: "查看详情",
            "aria-label": "查看详情"
          }, [...(_cache[19] || (_cache[19] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
          }), _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
          })], -1)]))], 8, _hoisted_32)])])]);
        }), 128))])])])]), pagination.total > 0 ? (_openBlock(), _createBlock(AppPagination, {
          key: 0,
          class: "pagination-bridge",
          pagination: pagination,
          "page-sizes": [10, 20, 50],
          onPageChange: handlePageChange,
          onSizeChange: handlePageSizeChange
        }, null, 8, ["pagination"])) : _createCommentVNode("", true)])])]), _createVNode(ProductSelector, {
          visible: showAddModal.value,
          "onUpdate:visible": _cache[3] || (_cache[3] = $event => showAddModal.value = $event),
          modelValue: addSelectedProductIds.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => addSelectedProductIds.value = $event),
          "product-tree": unauthorizedProductTree.value,
          title: "新增产品授权",
          description: authorizeDescription.value,
          onConfirm: handleAuthorizeConfirm
        }, null, 8, ["visible", "modelValue", "product-tree", "description"]), _createVNode(ProductDetailModal, {
          modelValue: showDetailModal.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => showDetailModal.value = $event),
          "product-id": selectedProductId.value,
          categories: categories.value
        }, null, 8, ["modelValue", "product-id", "categories"])]),
        _: 1
      });
    };
  }
};